import React from 'react';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Roles from './Roles';
import RoleAccess from './RoleAccess';

const RolesTab = () => {

    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="Org's">
                    <Tab label="Role" value="1" />
                    <Tab label="Role Access" value="2" />              
                </TabList>
                </Box>
                <TabPanel value="1">
                    <Roles />
                </TabPanel>
                <TabPanel value="2">
                    <RoleAccess />
                </TabPanel>                
            </TabContext>
        </Box>
    );
};
export default RolesTab;